/* tslint:disable */
 
import { ActionInfo } from './action-info';
import { AnonymousViewOption } from './anonymous-view-option';
import { ApplicationSharing } from './application-sharing';
import { AuthenticatedViewOption } from './authenticated-view-option';
import { EmbeddedPageConfig } from './embedded-page-config';
import { GenericViewAutoRefresh } from './generic-view-auto-refresh';
import { GenericViewComponent } from './generic-view-component';
import { GenericViewDisplayConfig } from './generic-view-display-config';
import { GenericViewGroup } from './generic-view-group';
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';
import { NullableReferenceProperty } from './nullable-reference-property';
import { PageHelp } from './page-help';
import { Permission } from './permission';
import { RedirectionRule } from './redirection-rule';
import { ReferenceProperty } from './reference-property';
import { SideBarConfig } from './side-bar-config';

/**
 * (tsType: Omit<GenericViewPermissionsDtoWithRelations, >, schemaOptions: { includeRelations: true, title: 'genericPermissionsDto', exclude: [] })
 */
export class GenericPermissionsDto {
  allowExportPDF?: boolean;
  anonymous?: null | AnonymousViewOption;
  authenticated?: null | AuthenticatedViewOption;
  autoRefresh?: null | GenericViewAutoRefresh;
  components?: Array<GenericViewComponent>;
  creationInfo?: ActionInfo;
  defaultPageForSpaces?: Array<ReferenceProperty>;
  description?: null | NullableLocalizedValue;
  displayConfig?: null | GenericViewDisplayConfig;
  displayOrder?: number;
  domain?: ReferenceProperty;
  embeddedPageConfig?: null | EmbeddedPageConfig;
  groups?: Array<GenericViewGroup>;
  help?: null | PageHelp;
  icon?: null | Icon;
  id?: string;
  isPinned?: boolean;
  isPublished?: boolean;
  name: LocalizedValue;
  pageType?: 0 | 1;
  permissions?: Array<Permission>;
  redirectionRules?: Array<RedirectionRule>;
  relatedTo?: null | NullableReferenceProperty;
  sharing: ApplicationSharing;
  sideBarConfig?: null | SideBarConfig;
  specificationVersion: number;
  uiAttributes?: null | {
};
  updateIdentifier: string;
  updateInfo?: ActionInfo;
}
